import React        from 'react'

const Container = props => {
    return (
        <div className="services-container">
            { props.children }
        </div>
    )
}

export default Container
